import intl from 'react-intl-universal';
import { CURRENT_LOCALE } from '@src/constants/CookieKey';
import { getTargetCookie, setCookie } from '@src/utils/cookie';

const { history } = window;

export enum LocaleValue {
    en = 'en-US',
    zh = 'zh-CN'
}
const locales = {
    [LocaleValue.en]: require('./language/en-US.ts').default,
    [LocaleValue.zh]: require('./language/zh-CN.ts').default
};

export const getCurrentLocale = (): LocaleValue => {
    const navigatorLocale = navigator.language.toLowerCase().includes('e')
        ? LocaleValue.en
        : LocaleValue.zh;
    // 配合面试信息登记表的语言设置
    const currentLocale = (getTargetCookie(CURRENT_LOCALE) as LocaleValue) || navigatorLocale;
    return currentLocale;
};

export const isEn = () => {
    return getCurrentLocale() === LocaleValue.en;
};

export const registerLanguage = async () => {
    await intl.init({ currentLocale: getCurrentLocale(), locales });
};

export const changeLanguage = (lang: LocaleValue, reloadUrl?: string) => {
    setCookie(CURRENT_LOCALE, lang);
    if ('scrollRestoration' in history) {
        history.scrollRestoration = 'manual';
    } else {
        window.onunload = () => window.scrollTo(0, 0);
    }
    if (!reloadUrl) {
        window.location.reload();
    } else {
        window.location.href = reloadUrl;
    }
};